import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ed3f61c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white px-1 py-3" }
const _hoisted_2 = { class: "d-flex justify-between gap-1" }
const _hoisted_3 = { class: "d-flex gap-1 align-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " d x ", -1))
const _hoisted_9 = ["value", "onChange"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  +  ", -1))
const _hoisted_11 = ["value", "onChange"]

import { request } from "@/domains/api/api";
import { useLoading } from "@/domains/app/loading";
import { reactive, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const powers = [3, 4, 5, 6, 7] as const;

const { loading, setLoading } = useLoading("km-prices");
const error = ref<string | null>(null);

const modified = ref(false);

const kmPrices = reactive<
    Record<
        string,
        {
            [K in typeof powers[number]]: [
                [number, number],
                [number, number],
                [number, number]
            ];
        }
    >
>({});
const newYear = ref(new Date().getFullYear());

request<typeof kmPrices>("km-prices", "get", () => null)
    .then((rs) => {
        if (rs === null) return;
        for (const year in rs) {
            kmPrices[year] = rs[year];
        }
    })
    .catch(() => (error.value = "Une erreur est survenue"))
    .finally(() => setLoading(false));

function addYear() {
    if (kmPrices[newYear.value] !== undefined) return;
    kmPrices[newYear.value] = {
        "3": [
            [0, 0],
            [0, 0],
            [0, 0],
        ],
        "4": [
            [0, 0],
            [0, 0],
            [0, 0],
        ],
        "5": [
            [0, 0],
            [0, 0],
            [0, 0],
        ],
        "6": [
            [0, 0],
            [0, 0],
            [0, 0],
        ],
        "7": [
            [0, 0],
            [0, 0],
            [0, 0],
        ],
    };
    newYear.value = new Date().getFullYear();
    modified.value = true;
}

function save() {
    if (!modified.value) return;
    setLoading(true);
    error.value = null;
    request<typeof kmPrices>(
        "km-prices",
        "put",
        (e) => {
            throw e;
        },
        {
            data: kmPrices,
        }
    )
        .then((rs) => {
            if (!rs) return;
            Object.keys(kmPrices).forEach((key) => delete kmPrices[key]);
            for (const year in rs) {
                kmPrices[year] = rs[year];
            }
            modified.value = false;
        })
        .catch(() => (error.value = "Une erreur est survenue"))
        .finally(() => setLoading(false));
}

function handleChange(
    e: Event,
    year: string,
    power: typeof powers[number],
    index: number,
    index2: number
) {
    const target = e.target as HTMLInputElement;
    const value = parseFloat(target.value);
    console.log(value);
    if (isNaN(value)) return;
    kmPrices[year][power][index][index2] = Math.round(value * 1000);
    modified.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newYear).value = $event))
        }, null, 512), [
          [_vModelText, newYear.value]
        ]),
        _createElementVNode("button", {
          onClick: addYear,
          type: "button",
          class: "btn btn-secondary"
        }, " Ajouter une année ")
      ]),
      (modified.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: save,
            type: "button",
            class: "btn btn-primary"
          }, " Enregistrer "))
        : _createCommentVNode("", true)
    ]),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Une erreur est survenue ..."))
      : _createCommentVNode("", true),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Chargement ..."))
      : _createCommentVNode("", true),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(kmPrices), (prices, year) => {
        return (_openBlock(), _createElementBlock("li", { key: year }, [
          _createElementVNode("h2", null, _toDisplayString(year), 1),
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_6,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                                    '-5000km',
                                    '5001-20000km',
                                    '+20001 km',
                                ], (slice) => {
                  return _createElementVNode("th", { key: slice }, _toDisplayString(slice), 1)
                }), 64))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prices, (powerPrices, power) => {
                return (_openBlock(), _createElementBlock("tr", { key: power }, [
                  _createElementVNode("td", null, _toDisplayString(power) + _toDisplayString(power == 3 ? "-" : power == 7 ? "+" : "") + " CV ", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(powerPrices, (slicePrices, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: power + index
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("input", {
                          required: "",
                          min: "0.001",
                          type: "number",
                          value: slicePrices[0] / 1000,
                          onChange: 
                                            (e) =>
                                                handleChange(
                                                    e,
                                                    year,
                                                    power,
                                                    index,
                                                    0
                                                )
                                        ,
                          step: "0.001"
                        }, null, 40, _hoisted_9),
                        _hoisted_10,
                        _createElementVNode("input", {
                          required: "",
                          min: "0",
                          type: "number",
                          value: slicePrices[1] / 1000,
                          onChange: 
                                            (e) =>
                                                handleChange(
                                                    e,
                                                    year,
                                                    power,
                                                    index,
                                                    1
                                                )
                                        ,
                          step: "0.001"
                        }, null, 40, _hoisted_11)
                      ])
                    ]))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})